// eslint-disable

import React, { useCallback, useMemo, useState, useEffect } from 'react'

import MaterialTableCustom from '../../../components/MaterialTableCustom'
import { useUpdateVendor, useAddVendor, useDeleteVendor } from '../../../hooks/queries'

const AllVendorsTable = ({ data, refreshTableData }) => {
  const { mutateAsync: addVendor } = useAddVendor()
  const { mutateAsync: updateVendor } = useUpdateVendor()
  const { mutateAsync: deleteVendor } = useDeleteVendor()
  const [deliveryData, setVendorData] = useState(data)

  useEffect(() => {
    if (!data) return
    //MAPPING THROUGH THE DATA AND FORMATTING IT AS PER REQUIRED BY THE TABLE
    const new_data = data
      .sort((a, b) => new Date(a?.dateOfRecord) - new Date(b?.dateOfRecord))
      .map((d) => ({
        ...d,
        trackingNumber: d?.tracking?.trackingNumber,
        carrier: d?.tracking?.carrier,
        trackingStatus: d?.tracking?.status,
      }))
    setVendorData([...new_data])
  }, [data])

  const onRowAdd = useCallback(async (newData) => {
    await addVendor(newData)
    refreshTableData()
  }, [])

  const onRowUpdate = useCallback(async (newData) => {
    await updateVendor(newData)
    refreshTableData()
  }, [])

  const onRowDelete = useCallback(async (oldData) => {
    await deleteVendor({ id: oldData.id })
    refreshTableData()
  }, [])

  const columns = useMemo(
    () => [
      { title: 'Vendor Name', field: 'vendorName' },
      { title: 'Vendor Email', field: 'vendorEmail' },
      { title: 'PN', field: 'partNumber' },
    ],
    [],
  )
  return (
    <MaterialTableCustom
      title={'Vendors Summary'}
      columns={columns}
      rowStyle={{
        fontSize: '12px',
        paddingTop: 0,
        paddingBottom: 0,
        height: 0,
      }}
      headerStyle={{
        marginTop: -5,
        paddingTop: 0,
        paddingBottom: 5,
      }}
      cellStyle={{
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 135,
      }}
      data={deliveryData}
      options={{
        filtering: false,
        search: true,
        paging: false,
        actionsColumnIndex: 10,
        maxBodyHeight: '600px',
      }}
      editable={{
        onRowAdd,
        onRowUpdate,
        onRowDelete,
      }}
    />
  )
}

export default AllVendorsTable
